/*
 * @Description: 重写element-ui message，只弹一次，避免重复弹
 */
import { Message } from "element-ui";
import {
  ElMessageOptions,
  ElMessageComponent,
  MessageType,
} from "element-ui/types/message";

const showMessage = Symbol("showMessage");
let messageInstance: ElMessageComponent;
class DoneMessage {
  [showMessage](type: MessageType, options: ElMessageOptions, single: boolean) {
    if (messageInstance && single) {
      messageInstance.close();
    }
    messageInstance = Message[type](options);
  }
  info(options: ElMessageOptions, single = true) {
    this[showMessage]("info", options, single);
  }
  warning(options: ElMessageOptions, single = true) {
    this[showMessage]("warning", options, single);
  }
  error(options: any, single = true) {
    console.log("options", options);

    this[showMessage]("error", options, single);
  }
  success(options: ElMessageOptions, single = true) {
    this[showMessage]("success", options, single);
  }
}
const message = new DoneMessage();
export default message;
